import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Roles } from "@/constants/roles";
import { DataContext } from "@/providers/DataProviders/DataProvider";
import { useSnackbar } from "@/providers/GlobalSnackbarProvider/GlobalSnackbarProvider";
import API from "@/axios/API";

const useAuthUtils = () => {
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { setMailId, setToken, setUserId, setFirstName, setLastName, setMetaData, setProfileStatus, setLoginCustomerId, setUserRole, setIsBetaUser } = useContext(DataContext);

    /** Retrieve Available Modules based on user Role. This determines the available nav items in sidebar, to user. */
    const getModulesByRole = (userRole) => {
        const modulesMap = {
            [Roles.NORMAL_USER]: [
                { id: 1, name: "Dashboard", moduleType: "Module" },
                { id: 2, name: "Billing", moduleType: "Module" },
                { id: 7, name: "Orders", moduleType: "Module" },
                { id: 3, name: "Profile Settings", moduleType: "Module" },
                { id: 4, name: "Email", moduleType: "Module" },
                { id: 8, name: "Registar Credentials", moduleType: "Module" },
                { id: 9, name: "Prewarm", moduleType: "Module" },
                { id: 10, name: "Sequencers", moduleType: "Module" },
                { id: 11, name: "Domain", moduleType: "Module" },
                { id: 12, name: "Affiliate", moduleType: "Module" },
                { id: 6, name: "Support", moduleType: "Module" },
                { id: 12, name: "Wallet", moduleType: "Module" },
            ],
            [Roles.ADMIN]: [
                { id: 1, name: "Customer", moduleType: "Module" },
                { id: 2, name: "Dashboard", moduleType: "Module" },
                { id: 7, name: "Orders", moduleType: "Module" },
                { id: 3, name: "Email", moduleType: "Module" },
                { id: 5, name: "Billing", moduleType: "Module" },
                { id: 6, name: "Profile Settings", moduleType: "Module" },
                { id: 9, name: "Prewarm", moduleType: "Module" },
                { id: 13, name: "Wallet", moduleType: "Module" },
                { id: 10, name: "Report", moduleType: "Module" },
                // { id: 11, name: "Domain", moduleType: "Module" },
                { id: 12, name: "Support", moduleType: "Module" },
            ],
        };
        return modulesMap[userRole] || [];
    };

    /** build metadata object from data of login response. This is eventually stored in local storage. */
    const buildMetadata = (loginResponseData, modules) => {
        const { userName, token, roleId, roleName, roles, message: responseMessage } = loginResponseData;

        return {
            userName: userName,
            token: token,
            roleId: roleId,
            roleName: roleName,
            roles: [
                {
                    // TODO: Check with naveed for id, shouldn't it be "roleId"?
                    id: 2,
                    name: (roles && roles.some(r => r.name === Roles.NORMAL_USER)) ? Roles.NORMAL_USER : Roles.ADMIN,
                    modules: modules,
                },
            ],
            // TODO: Check with Naveed, Shouldn't it be taken from response data?
            status: 200,
            message: responseMessage,
        };
    }

    const storeUserDetails = (metaData, userId, token, userName, firstName, lastName, customerId, roles, isBetaUser) => {

        const hasUserRole = roles && roles.length > 0 && roles.some(r => r.name === Roles.NORMAL_USER);
        const assignedRole = hasUserRole ? Roles.NORMAL_USER : Roles.ADMIN;

        setUserRole(assignedRole);

        setMetaData(metaData);
        setUserId(userId);
        setFirstName(firstName);
        setLastName(lastName);
        setToken(token);
        setMailId(userName);
        setLoginCustomerId(customerId);
        setIsBetaUser(isBetaUser);
    };


    /** Send API Request to retrieve user details via Customer ID. */
    const getUserDetails = async (customerId, token) => {
        return await API.get(`${import.meta.env.VITE_BACKEND_API}/getuser`, {
            params: { customerId: customerId },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }

    /** Set Customer Profile Completion in local storage. It represents Customer Status. */
    const setCustomerProfileCompletion = (isOnboarded) => {
        setProfileStatus(isOnboarded);
    }

    /** Redirect user after login. Currently, "condition" represent user profile complete status/ */
    const postLoginRedirect = (condition) => {
        let settingsPath = `${import.meta.env.VITE_APP_BASE_PATH}/settings/`;
        let dashboardPath = `${import.meta.env.VITE_APP_BASE_PATH}/dashboard/`;

        if (condition) {
            navigate(settingsPath);
        } else {
            navigate(dashboardPath);
        }
    };

    /** Error Handling for login request based on HTTP Statuses. */
    const handleLoginError = (status) => {
        console.log(status)
        if (status === 403) {
            showSnackbar("Username does not exist", "error");
        } else if (status === 401) {
            showSnackbar("Invalid username or password", "error");
        } else if (status === 405) {
            showSnackbar("Your Login Access Has Been Disabled Contact Support Team !!", "error");
        } else if (status === 404) {
            showSnackbar("Incorrect password", "error");
        }
    };

    return { getModulesByRole, buildMetadata, storeUserDetails, getUserDetails, setCustomerProfileCompletion, postLoginRedirect, handleLoginError };
};

export default useAuthUtils;
